import initSliders from "../components/initSliders.js";
import initLightbox from "../components/initLightbox.js";

document.addEventListener("DOMContentLoaded", () => {

    const {
        initPhotosSlider,
    } = initSliders();

    initPhotosSlider();
    initLightbox();

});
